import styled from "styled-components";
import { size } from "styled-theme";
import cx from "classnames";
import React from "react";

export const CrumbBarStyle = styled.div`
  height: 5px;
  background-color: #c0c0c0;
  
  &.is-hidden {
    display: block;
    visibility: hidden;
  }

  &.is-active {
    background-color: #c0c0c0;
    @media only screen and (min-width: ${size("M")}) {
      background-color: #c0c0c0;
    }
  }
`;

export const CrumbBar = ({isActive, isHidden}) => (
  <CrumbBarStyle className={cx({'is-active': isActive, 'is-hidden': isHidden})} />
);